import styled from 'styled-components';
import { Cropper } from 'react-cropper';
import { CustomButton } from '@mindly/ui-components';
import { IonModal } from '@ionic/react';

type WidthAndHeightProps = {
  width?: number;
  height?: number;
};

export const CustomIonModal = styled(IonModal)<WidthAndHeightProps>`
  &::part(content) {
    border-radius: 10.1361px;
    height: auto;
    max-width: 410px;
    width: auto;
    max-height: 90vh;
    margin: 16px;
    z-index: 12;
  }

  &::part(backdrop) {
    z-index: 11;
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledModalButton = styled(CustomButton)`
  border-radius: 0px 0px 10.1361px 10.1361px;
`;

export const CustomCropper = styled(Cropper)<WidthAndHeightProps>`
  img {
    max-width: 100%;
  }
  .cropper-view-box {
    border-radius: 50%;
  }

  .cropper-face {
    background-color: inherit !important;
  }

  .cropper-canvas {
  }
`;
